import { makeStyles, Button } from '@material-ui/core'
import PropTypes from 'prop-types'
import { useRef, useState } from 'react'
import VariableMenu from 'components/variables/variablemenu'

// eslint-disable-next-line no-undef
const ReactQuill = typeof window === 'object' ? require('react-quill') : () => false

const useStyles = makeStyles(() => ({
  quill: {
    '& .ql-editor': {
      minHeight: '100px'
    }
  },
  center: {
    '& .ql-editor': {
      textAlign: 'center'
    }
  }
}))
export default function TextBox({ deltas, save, task, novars, placeholder, center }) {
  const classes = useStyles()
  const quillRef = useRef(null)
  const buttonRef = useRef(null)
  const setContent = useRef(null)
  const cursorRef = useRef(null)
  const [modules, setModules] = useState(false)
  const [showVariableMenu, setShowVariableMenu] = useState(false)

  if (!modules) setModules({
    toolbar: {
      container: [//[{ size: ['small', false, 'large', 'huge'] }],
        ['bold', 'italic', 'underline', 'strike'],
        ['link'],
        [{ 'list': 'ordered' }, { 'list': 'bullet' }],
        [{ 'size': ['small', false, 'large', 'huge'] }],
        [{ 'indent': '-1' }, { 'indent': '+1' }],
        [{ 'color': [] }, { 'background': [] }],
      ],
    }
  })

  function insertVariable() {
    const quill = quillRef.current.getEditor()
    const caretPosition = quill.getSelection(true)
    setShowVariableMenu(true)
    setContent.current = v => quill.insertText(caretPosition.index, `{{ ${v} }}`, 'user')
  }

  // Set the cursor to the original point on re-render
  if (cursorRef.current) {
    const quill = quillRef.current.getEditor()
    quill.setSelection(cursorRef.current)
  }

  let className = classes.quill
  if (center) className = `${classes.quill} ${classes.center}`

  return <>
    <ReactQuill placeholder={placeholder} ref={quillRef} className={className} modules={modules} value={deltas} theme="snow"
      onChange={(html, _, who, editor) => {
        if (JSON.stringify(editor.getContents().ops) == JSON.stringify(deltas) || who === 'api') return
        save(html, editor.getContents().ops)
        cursorRef.current = editor.getSelection()
      }}
      onKeyUp={() => {
        const quill = quillRef.current.getEditor()
        const editor = quillRef.current.makeUnprivilegedEditor(quill)
        save(editor.getHTML(), quill.getContents().ops)
        cursorRef.current = quill.getSelection()
      }}
      onChangeSelection={(range, who) => {
        if (who !== 'user') return
        cursorRef.current = range
      }} />
    {!novars && <>
      <Button ref={buttonRef} variant='outlined' style={{ display: 'block' }} onClick={insertVariable}>Insert Variable</Button>
      <VariableMenu task={task || {}} showVariableMenu={showVariableMenu} setShowVariableMenu={setShowVariableMenu} setContent={v => setContent.current(v)} anchorEl={buttonRef.current} />
    </>}
  </>

}

TextBox.propTypes = {
  deltas: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array
  ]).isRequired,
  save: PropTypes.func.isRequired,
  task: PropTypes.object,
  novars: PropTypes.bool,
  placeholder: PropTypes.string,
  center: PropTypes.bool
}